"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Header = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var react_1 = __importDefault(require("react"));
var models_1 = require("../../../models");
var StyledHeader = styled_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n\n  label: Header;\n"], ["\n  color: ", ";\n\n  label: Header;\n"])), function (_a) {
    var color = _a.color;
    return color;
});
var Header = function (_a) {
    var header = _a.header, color = _a.color, className = _a.className;
    if (header.type === models_1.FORM_PAGE_HEADER_TYPE.rawHtml) {
        return (react_1.default.createElement(StyledHeader, { color: color, className: className, dangerouslySetInnerHTML: {
                __html: header.rawHtml,
            } }));
    }
    return null;
};
exports.Header = Header;
var templateObject_1;
